(function() {
  const handleItemClick = (e, line_item) => {
    const afterClick = new Event("algoliaShopify.autocomplete.hitClickAction");
    document.dispatchEvent(afterClick);

    if (algoliaShopify.config.analytics_enabled) {
      const clickData = {
        index: line_item.__autocomplete_indexName,
        eventName: "Added to cart",
        queryID: line_item.__autocomplete_queryID,
        objectIDs: [line_item.objectID],
      };
      algoliaShopify.saveForConversionTracking(clickData);
    }

    const customerCustomAction = algoliaShopify.hooks.triggerHooks(
      "afterAutocompleteProductClickAction",
      undefined,
      line_item
    );

    if (typeof customerCustomAction === "function") {
      customerCustomAction();
    }
  };

  document.addEventListener("algolia.hooks.initialize", function() {
    algoliaShopify.hooks.registerHook(
      "beforeAutocompleteProductTemplate",
      function(_defaultTemplate, templateOptions, distinct, itemLink) {
        // Modify default options, then return them
        const { html, item, components } = templateOptions;
        return html`
          <a
            href="${itemLink}"
            class="aa-ItemLink aa-ProductItem"
            onClick="${(event) => handleItemClick(event, item)}"
          >
            <div class="aa-ItemContent">
              <div class="aa-ItemPicture aa-ItemPicture--loaded">
                <img
                  src="${algoliaShopify.helpers.largeImage(item)}"
                  alt="${item.title}"
                />
              </div>
              <div class="aa-ItemContentBody">
                <div class="aa-ItemContentBrand">
                  ${
                    item.sku
                      ? components.Highlight({ hit: item, attribute: "sku" })
                      : item.product_type &&
                        components.Highlight({ hit: item, attribute: "product_type" })
                  }
                </div>
                <div class="aa-ItemContentTitleWrapper">
                  <div class="aa-ItemContentTitle">
                    ${components.Highlight({ hit: item, attribute: "title" })}
                    <span class="algolia-variant">
                      ${item.variant_title}
                    </span>
                  </div>
                </div>
                <div class="aa-ItemContentPrice">
                  <div class="aa-ItemContentPriceCurrent">
                    ${algoliaShopify.helpers.displayPrice(item, distinct)}
                  </div>
                </div>
              </div>
            </div>
          </a>
        `;
      }
    );
  });
})();
